const style = 'color: #5d7ae1; font-weight: bold;';

export const log = (
  message: string,
  payload: unknown = null,
  type: 'error' | 'debug' | 'warn' = 'debug',
) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  const prefixedMessage = `%c🏷️ Analytics: ${message}`;

  const args: unknown[] = [prefixedMessage, style];

  if (payload) {
    args.push(payload);
  }

  if (type === 'error') {
    // eslint-disable-next-line no-console
    console.error(...args);
  } else if (type === 'warn') {
    // eslint-disable-next-line no-console
    console.warn(...args);
  } else {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};

export const logEventWarning = (event: string) => {
  log('-----------------------------', undefined, 'warn');
  log(`${event} event already sent with the same requested products, skipping`, undefined, 'warn');
  log('you need to fix your analytics code to avoid this', undefined, 'warn');
  log('-----------------------------', undefined, 'warn');
};
